import { lazy } from "react";

const CtaBottomLazy = lazy(() => import("../CtaBottom"));

export default CtaBottomLazy;